// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3uCku","title":"styles_title__22qNT"};